import React from "react";

/**
 * Landworth Logo Component with responsive sizing
 * Adapts to scroll state for compact and full modes
 */
export function LandworthLogo({ isCompact, className = "" }) {
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/LANDWORTH-logo-v2-h140.png"
        alt="Landworth"
        className={`transition-all duration-300 ${
          isCompact ? "h-8 w-auto" : "h-10 w-auto"
        }`}
      />
    </div>
  );
}

export default LandworthLogo;
